import axios from '../external/Axios';
import Url from '../constants/Url';

class TaxProfileApi {
    getTaxRecord(params) {
        return axios.get(Url().TAX.GET_PROFILE, {params})
            .then(response => {
                return response.data.data;
            })
            .catch(ex => {
                console.info('Failed to get tax profile', ex.message);
                throw ex;
            });
    }

    pullTaxRecord() {
        return axios.put(Url().TAX.PULL_PROFILE)
            .then(response => {
                return response;
            })
            .catch(ex => {
                console.info('Failed to pull record', ex.message);
                throw ex;
            });
    }

    updateTaxRecord(params) {
        return axios.put(Url().TAX.UPDATE_PROFILE, params)
            .then(response => {
                return response.data.data;
            })
            .catch(ex => {
                console.info('Failed to update record', ex.message);
                throw ex;
            });
    }

    getInterview(data) {
        return axios.post(Url().TAX.GET_INTERVIEW, data)
            .then(response => {
                return response.data.data;
            }).catch(ex => {
                console.info('Failed to get tax interview', ex.message);
                throw ex;
            });
    }

    getConsentInterview(data) {
        return axios.post(Url().TAX.GET_CONSENT_INTERVIEW, data)
        .then(response => {
            return response.data.data;
        }).catch(ex => {
            console.info('Failed to consent tax interview', ex.message);
            throw ex;
        });
    }

    getAccountStatus() {
        return axios.get(Url().TAX.GET_PAYOUT_ACCOUNT_STATUS)
            .then(response => {
                return response.data.data;
            })
            .catch(ex => {
                console.info('Failed to get account status', ex.message);
            });
    }

    getTaxRetakeAvailable() {
        return axios.get(Url().TAX.GET_RETAKE_AVAILABLE)
        .then(response => {
            return response.data.data;
        })
        .catch(ex => {
            console.info('Failed to get retake available', ex.message);
        });
    }

    traceTakeInterview() {
        return axios.post(Url().TAX.TRACE_TAKE_INTERVIEW, {});
    }

    getTaxDocuments() {
        return axios.get(Url().TAX.GET_TAX_DOCUMENTS)
            .then(response => {
                return response.data.data;
            })
            .catch(ex => {
                console.info('Failed to get tax documents', ex.message);
                throw ex;
            });
    }
}

export default new TaxProfileApi();
